import { render, staticRenderFns } from "./Api.vue?vue&type=template&id=736d38cc&scoped=true"
import script from "@/scripts/common/api.js?vue&type=script&lang=js&external"
export * from "@/scripts/common/api.js?vue&type=script&lang=js&external"
import style0 from "./Api.vue?vue&type=style&index=0&id=736d38cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736d38cc",
  null
  
)

export default component.exports